import {gql, useMutation} from '@apollo/client';
import {SetInJourney, SetInJourneyVariables} from '../schema-types/SetInJourney';

const updateReviewInJourney = gql`
  mutation SetInJourney($reviewId: UUID!, $annualReview: Boolean) {
    updateReview(reviewId: $reviewId, annualReview: $annualReview, isInJourney: true) {
      errors
      review {
        id
        isInJourney
        isDraft
        annualReview
      }
    }
  }
`;

export const useSetIsJourneyToTrue = () => {
  const [setIsJourneyToTrue] = useMutation<SetInJourney, SetInJourneyVariables>(
    updateReviewInJourney
  );

  return {setIsJourneyToTrue};
};
